import { navigation } from "../components/layout/Navbar";

const normalizePath = (path) => {
  path = path || "";
  path = path.endsWith("/") ? path.slice(0, -1) : path;
  path = path.startsWith("/") ? path.slice(1) : path;
  path = path.split("?")[0];
  return path.toLowerCase();
};

const getMenuItemFromPath = (path) => {
  const navItems = {};
  const indexNavItems = (items) => {
    items.forEach((item) => {
      navItems[normalizePath(item.href)] = item;
      if (item.submenu) {
        indexNavItems(item.submenu);
      }
    });
  };
  indexNavItems(navigation);
  return navItems[normalizePath(path)];
};

export const prettifyRoute = (route) => {
  const menuItem = getMenuItemFromPath(route);
  if (menuItem) {
    return {
      name: menuItem.name,
      icon: menuItem.icon,
      hint: menuItem.hint,
    };
  }
  return {
    name: route,
    icon: null,
    hint: null,
  };
};
